import t from 'react-translate';
import { config } from '@config/pendo.config.json';
import { RolePlayInteractionMode } from 'redux/schemas/models/ai-role-play';

const usageManagementDataQa = config.pendo.activities.aiRolePlay.usageManagement;

export type RoleplayModality = {
  type: RolePlayInteractionMode,
  icon: string,
  label: () => string,
  dataQa: string,
  // CSS gradient background of the icon badge in the course-list "Approved Roleplay Types" column.
  badgeBackground: string,
};

export const ROLEPLAY_MODALITIES: RoleplayModality[] = [
  {
    type: RolePlayInteractionMode.TEXT,
    icon: 'comments',
    label: () => t.AI_ROLEPLAY.COURSE_LEVEL_MANAGEMENT.MODALITY.TEXT(),
    dataQa: usageManagementDataQa.typeText,
    badgeBackground: 'linear-gradient(77.65deg, #E4E7EC 0%, #DEE1E5 33.83%, #D4D5D7 96.4%)',
  },
  {
    type: RolePlayInteractionMode.VOICE,
    icon: 'audio-recording',
    label: () => t.AI_ROLEPLAY.COURSE_LEVEL_MANAGEMENT.MODALITY.VOICE(),
    dataQa: usageManagementDataQa.typeVoice,
    badgeBackground: 'linear-gradient(48.41deg, rgba(96, 243, 171, 0.4) 0%, rgba(0, 204, 188, 0.4) 45%, rgba(0, 154, 192, 0.4) 100%)',
  },
];

export const modalityIcon = (type: RolePlayInteractionMode): string => (
  ROLEPLAY_MODALITIES.find((modality) => modality.type === type)?.icon ?? ''
);
